module.exports = __webpack_public_path__ + "img/student_29.3b016cb1.png";